import React from "react";
import { Container, Typography } from "@material-ui/core";

import { AdminCustomersTable } from "./AdminCustomersTable";

export const AdminCustomersView: React.FC = () => {
  return (
    <Container
      style={{
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "4em 0 2rem",
      }}
    >
      <Typography
        variant="h3"
        style={{ marginBottom: "1rem" }}
      >
        Customers
      </Typography>
      <Container maxWidth="md" style={{ padding: "2rem 0" }}>
        <AdminCustomersTable />
      </Container>
    </Container>
  );
};

